export function Divider() {
  return (
    <div className="mb-4 border-t border-t-[var(--content-neutral-light)]">
      <hr className="m-0 border-none" />
    </div>
  );
}
